import { isBoolean } from 'lodash'

import { validatorCreator } from 'utils/helpers/validators/validatorCreator'

export const VALIDATION_ERRORS_ENUM = {
  SHOULD_BE_SIGNED: 'This signature is required.',
}

const signatureValidators = [
  {
    name: 'Signature is required',
    isValid: ({ value, isRequired }) => !isRequired || (isBoolean(value) && value),
    errorMessage: VALIDATION_ERRORS_ENUM.SHOULD_BE_SIGNED,
  },
]

export const validateSignature = validatorCreator(signatureValidators)
